import React from 'react';
import Role_Creation from './Role_Creation';

const Role_MasterApp = () => { 
  return (
  <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Role Creation</h5>
          </div>
        </div>
        <Role_Creation />
      </div>
    </div >
  );
};

export default Role_MasterApp;
